import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";

export interface BetWayWin {
    amount: number;
    length: number;
    mode: string; //<--- TODO not needed by client
    multipliedAmount: number;
    multiplier: number;
    numberOfCombinations: number;
    symbol: string;
}

export interface XwaysHoarder2Data {
    accumulatedRoundWin: number;
    boostedBet: boolean;
    freespinsPlayed: number;
    featureBuyTimesBetValue: FeatureBuyTimesBetValue[];

    mode: string;
    nextMode: string;
    reels: string[][];

    nextRespinIstheLast: boolean,
    reSpinTriggeredByAnotherLoot: boolean,
    thisRespinIsTheLastReSpinReSpin: boolean,
    featureMap: { [key: string]: any } [];
    freespinsLeft: number;

    currentTopBarProgression: number [];
    nextTopBarProgression: number [];

    currentFSLevel: number;
    nextFSLevel: number;

    nextRespinIsTheLastReSpin: boolean;

    symbolSizesAfterCollapse: number [][];
    reelsAfterCollapse: string [][];

    wasFeatureBuy: boolean;

    totalWays: number;
    addedNumberOfFreeSpinInThisSpin: number


}

export interface XwaysHoarder2GameData extends XwaysHoarder2Data {
    evaluatedArea: string [][];
    totalSpinWinnings: number;
    playedBetValue: number;
    brokeTheBank: boolean;

    symbolSizesAtStart: number [][];
    symbolSizes: number [][];
    betWayWins: IBetWayWinData[];
}

export function isXwaysHoarder2GameData(value: any): value is XwaysHoarder2GameData {
    return value.betWayWins !== undefined;
}

export interface XwaysHoarder2InitData extends XwaysHoarder2GameData {
    isRestoreState: boolean;
    freespinsLeft: number;
    symbolValues: any; // SymbolValues - model
    nextPlayerInteraction?: any;

    symbolSizesAtStart: number [][];
    symbolSizes: number [][];
    reelsAfterCollapse: string [][];

}

export interface SymbolValues {
    [symbolName: string]: {
        3: number, 4: number, 5: number, 6: number
    }
}
